import { Action } from "redux";
import { AssetFormState, defaultAdUnitBuilderState } from "../state";
import { getCurrentAssetDefForm } from "../adUnitAssetBuilderForm";
import { AddAdUnitBuilderAssetAction, RemoveAdUnitBuilderAssetAction, CleanAdUnitBuilderAssetAction } from "../actions";
import { range } from "../../../common";

export function assetFormReducer(state: AssetFormState, action: Action): AssetFormState {
    const forms = getCurrentAssetDefForm();

    if (forms) {
        if (forms.main.form.actions.isMyAction(action)) {
            return {
                ...state,
                main: forms.main.form.reducer(state.main, action)
            };
        }

        for (const assetProperty of Object.keys(forms.nested)) {
            const form = forms.nested[assetProperty];
            if (form.form.actions.isMyAction(action)) {
                const currentData = state.nested[assetProperty] || [];
                const newData = [...currentData];

                newData[action.meta.index] = form.form.reducer(currentData[action.meta.index], action);

                return {
                    ...state,
                    nested: {
                        ...state.nested,
                        [assetProperty]: newData
                    }
                };
            }
        }

        if (AddAdUnitBuilderAssetAction.is(action)) {
            const form = forms.nested[action.assetPropery];
            if (!form.isCollection) {
                return state;
            }

            const formData = state.nested[action.assetPropery] || range(form.min).map(() => form.form.state.empty());
            if (formData.length === form.max) {
                return state;
            }

            return {
                ...state,
                nested: {
                    ...state.nested,
                    [action.assetPropery]: [...formData, form.form.state.empty()]
                }
            };
        }

        if (RemoveAdUnitBuilderAssetAction.is(action)) {
            const form = forms.nested[action.assetPropery];
            if (!form.isCollection) {
                return state;
            }

            const formData = state.nested[action.assetPropery] || range(form.min).map(() => form.form.state.empty());
            if (formData.length === form.min) {
                return state;
            }

            const elementToRemove = formData[action.index];

            return {
                ...state,
                nested: {
                    ...state.nested,
                    [action.assetPropery]: formData.filter(e => e !== elementToRemove)
                }
            };
        }
        if (CleanAdUnitBuilderAssetAction.is(action)) {
            return {
                ...state,
                main: defaultAdUnitBuilderState.assetForms.main,
                nested: defaultAdUnitBuilderState.assetForms.nested
            };
        }
    }

    return state;
}
